// ══════════════════════════════════════════════════════════════════════════════════════════════
//  FACE ID UNA VEZ, SIN BUCLE  (t169b y t169c, 12-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño (12-oct-2026): «en iphone, sigue habiendo mucho fallo con el faceid, hace un bucle y lo pide como 5 veces cuando
//  te ha sacado por seguridad», y después: «¿no puede salir automáticamente lo de Face ID sin tener que pulsar un botón?».
//  Sale sola UNA vez por bloqueo (components/BloqueoPantalla) y al abrir la app (pages/Login), y para que no haya bucle:
//
//   1. UNA A LA VEZ. Mientras hay una hoja abierta (o esperando a abrirse), otra petición no sale: un toque con la hoja que
//      salió sola, un segundo componente o un «al volver» que se adelanta se quedan en nada (`conLaHoja` → EN_CURSO).
//   2. LO QUE PROVOCA LA HOJA NO ES «VOLVER A LA APLICACIÓN». Mientras está abierta y durante GRACIA_HOJA_MS después de
//      cerrarse, los cambios de foco y de visibilidad (iOS los mueve al abrirla y cerrarla) no lanzan otra ni cuentan como un
//      acceso ni como una vuelta (`hojaReciente`).
//
//  Sin hooks ni estado de React: lo usan servicios y pantallas por igual (una sola copia por página).

export const GRACIA_HOJA_MS = 2500

// La hoja que hay abierta ahora mismo, y cuándo se cerró la última.
let abierta = false
let abiertaAt = 0
let cerradaAt = 0
let vuelta = 0   // la de una hoja perdida que contesta tarde no cierra la que hay abierta ahora
// Una hoja que no contesta nunca (el sistema la perdió) no puede dejar la cara bloqueada para siempre: pasado este rato,
// más que el minuto que da la propia petición, se deja pedir otra.
const HOJA_PERDIDA_MS = 90 * 1000
export function hojaAbierta(ahora = Date.now()) { return abierta && ahora - abiertaAt < HOJA_PERDIDA_MS }
export function hojaReciente(ahora = Date.now()) { return hojaAbierta(ahora) || (cerradaAt > 0 && ahora - cerradaAt < GRACIA_HOJA_MS) }

// Pide la hoja con `fn` (la que llama a navigator.credentials.get o al complemento nativo). Si ya hay una abierta, NO sale
// otra: devuelve EN_CURSO (y quien llama no hace nada). Lo que devuelva o lance `fn` pasa tal cual.
export const EN_CURSO = Object.freeze({ enCurso: true })
export async function conLaHoja(fn) {
  if (hojaAbierta()) return EN_CURSO
  const mia = ++vuelta
  abierta = true; abiertaAt = Date.now()
  try { return await fn() } finally { if (mia === vuelta) abierta = false; cerradaAt = Date.now() }
}

// Solo para las pruebas: olvidar la hoja (cada prueba empieza con el aparato en reposo).
export function _reiniciarParaPruebas() { abierta = false; abiertaAt = 0; cerradaAt = 0 }
